import { useNavigate } from 'react-router';

import { useT } from '@/i18n';
import styles from '@/pages/pages.module.css';

import { ArrowLeftIcon } from './Icons';

/** The square ← that heads every screen: back to the first screen, or wherever `to` says. */
export function BackButton({ to = '/', label, testId = 'bridge-back' }: { readonly to?: string; readonly label?: string; readonly testId?: string }): React.JSX.Element {
  const t = useT();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={styles.backBtn}
      onClick={() => {
        void navigate(to);
      }}
      aria-label={label ?? t('backButton.label')}
      title={label ?? t('backButton.label')}
      data-testid={testId}
    >
      <ArrowLeftIcon size={18} />
    </button>
  );
}
